import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" {...props}><path fillRule="evenodd" d="M9 9H0v2h9v9h2v-9h9V9h-9V0H9v9z" /></svg>);